import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { ListBox as AriaListBox, ListLayout, Provider, Virtualizer } from "react-aria-components";
import { itemHeightM, itemHeightS, listBox } from "./ListBox.css.js";
import { DropdownItemContext } from "./shared/DropdownItemContext.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function ListBox(t0) {
  const $ = _c(18);
  let props;
  let scrollRef;
  let size;
  let t1;
  if ($[0] !== t0) {
    ({
      size,
      scrollRef,
      virtualized: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = scrollRef;
    $[3] = size;
    $[4] = t1;
  } else {
    props = $[1];
    scrollRef = $[2];
    size = $[3];
    t1 = $[4];
  }
  const virtualized = t1 === undefined ? false : t1;
  let t2;
  if ($[5] !== props.selectionMode || $[6] !== size) {
    t2 = [[DropdownItemContext, {
      size,
      selectionMode: props.selectionMode
    }]];
    $[5] = props.selectionMode;
    $[6] = size;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== scrollRef) {
    t3 = /*#__PURE__*/_jsx(AriaListBox, {
      ref: scrollRef,
      ...props,
      className: listBox
    });
    $[8] = props;
    $[9] = scrollRef;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = /*#__PURE__*/_jsx(Provider, {
      values: t2,
      children: t3
    });
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== size || $[15] !== t4 || $[16] !== virtualized) {
    t5 = /*#__PURE__*/_jsx(OptionalVirtualizedList, {
      virtualized: virtualized,
      size: size,
      children: t4
    });
    $[14] = size;
    $[15] = t4;
    $[16] = virtualized;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
const OptionalVirtualizedList = t0 => {
  const $ = _c(7);
  const {
    children,
    size: t1,
    virtualized
  } = t0;
  const size = t1 === undefined ? "m" : t1;
  const rowHeight = size === "s" ? itemHeightS : itemHeightM;
  if (!virtualized) {
    let t2;
    if ($[0] !== children) {
      t2 = /*#__PURE__*/_jsx(_Fragment, {
        children: children
      });
      $[0] = children;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== rowHeight) {
    t2 = {
      rowHeight
    };
    $[2] = rowHeight;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = /*#__PURE__*/_jsx(Virtualizer, {
      layout: ListLayout,
      layoutOptions: t2,
      children: children
    });
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
//# sourceMappingURL=ListBox.js.map